import { useCallback, useState } from 'react'

import { NotificationFilter } from '@/components/notification/notification-filter'
import { NotificationList } from '@/components/notification/notification-list'

import { useNotificationFilterStore } from '@/stores/notification-filter.store'
import { NotificationsFilterClient } from '@/types/notification'

const NotificationManagement = ({ onNotificationDisplayClick }: { onNotificationDisplayClick?: () => void }) => {
  const { isUnreadOnly, notificationTypeGroup, setIsUnreadOnly, setNotificationTypeGroup } =
    useNotificationFilterStore()

  const [filter, setFilter] = useState<NotificationsFilterClient>({
    groupType: notificationTypeGroup,
    isUnreadOnly,
    keyword: '',
  })

  const handleFilterChange = useCallback(
    (newFilter: NotificationsFilterClient) => {
      setFilter(newFilter)

      // update saved store filter
      setIsUnreadOnly(newFilter.isUnreadOnly)
      setNotificationTypeGroup(newFilter.groupType)
    },
    [setIsUnreadOnly, setNotificationTypeGroup],
  )

  return (
    <div className="flex h-full flex-col pb-6">
      <NotificationFilter
        className="border-base shrink-0 border-b bg-base-sidebar-background p-4 dark:bg-sidebar-foreground"
        initialFilter={filter}
        onFilterChange={handleFilterChange}
      />
      <div className="flex-1 overflow-hidden">
        <NotificationList filter={filter} onNotificationDisplayClick={onNotificationDisplayClick} />
      </div>
    </div>
  )
}
NotificationManagement.displayName = 'NotificationManagement'

export { NotificationManagement }
